export const FETCH_ASSESSMENT_ITEMS_STARTED = 'FETCH_ASSESSMENT_ITEMS_STARTED';
export const FETCH_ASSESSMENT_ITEMS_SUCCESS = 'FETCH_ASSESSMENT_ITEMS_SUCCESS';
export const FETCH_ASSESSMENT_ITEMS_FAILED = 'FETCH_ASSESSMENT_ITEMS_FAILED';

export const MAP_ASSIGNMENTS_SUCCESS = 'MAP_ASSIGNMENTS_SUCCESS';
export const MAP_ASSIGNMENTS_STARTED = 'MAP_ASSIGNMENTS_STARTED';
export const MAP_ASSIGNMENTS_FAILED = 'MAP_ASSIGNMENTS_FAILED';
export const MAP_ASSIGNMENTS_CLEAR = 'MAP_ASSIGNMENTS_CLEAR';

export const DOWNLOAD_CSV_STARTED = 'DOWNLOAD_CSV_STARTED';
export const DOWNLOAD_CSV_SUCCESS = 'DOWNLOAD_CSV_SUCCESS';
export const DOWNLOAD_CSV_FAILED = 'DOWNLOAD_CSV_FAILED';

export const EXPORT_GRADES_STARTED = 'EXPORT_GRADES_STARTED';
export const EXPORT_GRADES_SUCCESS = 'EXPORT_GRADES_SUCCESS';
export const EXPORT_GRADES_FAILED = 'EXPORT_GRADES_FAILED';
export const EXPORT_GRADES_EVENT_START = 'EXPORT_GRADES_EVENT_START';

export const FETCH_AI_STUDENT_GRADES_STARTED =
  'FETCH_AI_STUDENT_GRADES_STARTED';
export const FETCH_AI_STUDENT_GRADES_SUCCESS =
  'FETCH_AI_STUDENT_GRADES_SUCCESS';
export const FETCH_AI_STUDENT_GRADES_FAILED = 'FETCH_AI_STUDENT_GRADES_FAILED';

export const UPDATE_AI_STUDENT_GRADES_STARTED =
  'UPDATE_AI_STUDENT_GRADES_STARTED';
export const UPDATE_AI_STUDENT_GRADES_FAILED =
  'UPDATE_AI_STUDENT_GRADES_FAILED';
export const UPDATE_AI_STUDENT_GRADES_SUCCESS =
  'UPDATE_AI_STUDENT_GRADES_SUCCESS';

export const FETCH_ALL_CALCULATED_GRADES_STARTED =
  'FETCH_ALL_CALCULATED_GRADES_STARTED';
export const FETCH_ALL_CALCULATED_GRADES_SUCCESS =
  'FETCH_ALL_CALCULATED_GRADES_SUCCESS';
export const FETCH_ALL_CALCULATED_GRADES_FAILED =
  'FETCH_ALL_CALCULATED_GRADES_FAILED';
